// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import cookie from 'js-cookie';

const fragments = {
	INPUT_ALL: '[data-fragment="StageCheckboxSelect.inputAll"]',
	INPUT: '[data-fragment="StageCheckboxSelect.input"]',
};

export default class StageCheckboxSelect extends WebComponent {
	constructor(props) {
		super(props);
		this.init = this.init.bind(this);
		this.reset = this.reset.bind(this);
		this.toggleDropdown = this.toggleDropdown.bind(this);
	}
	didMount() {
		this.inputAll = this.element.querySelector(fragments.INPUT_ALL);
		this.inputs = this.element.querySelectorAll(fragments.INPUT);
		this.controlLabel = this.element.querySelector('.control-label');
		this.controlLabel.addEventListener('click',this.toggleDropdown);
		this.cookieName = 'stageCheckbox_'+this.element.id;
		if (this.inputs.length) {
			this.inputAll.addEventListener('click',this.reset);
			this.init();
		}
	}

	init() {
		let isChecked = false;
		this.inputs.forEach((input) => {
			if (input.checked) isChecked = true;
		});
		this.inputAll.checked = !isChecked;

		if (cookie.get(this.cookieName) && cookie.get(this.cookieName) === 'open') {
			this.element.classList.add('open');
		}
	}

	reset() {
		this.inputs.forEach((input) => {
			input.checked = false;
		});
	}

	toggleDropdown() {
		if (cookie.get(this.cookieName) && cookie.get(this.cookieName) === 'open') {
			cookie.set(this.cookieName, 'close', {expires: 1, path: '/'});
		} else {
			cookie.set(this.cookieName, 'open', {expires: 1, path: '/'});
		}
		this.element.classList.toggle('open');
	}
}



// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/StageCheckboxSelect.js